import React from "react";
import {
  Card,
} from '@aws-amplify/ui-react';
import { Link } from 'react-router-dom';
//import PaymentAddressDetails from "./PaymentAddressDetails";
//import PaymentCartDetails from "./PaymentCartDetails";
import '@aws-amplify/ui-react/styles.css';
import Modal from 'react-modal';
// Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
// Amplify configured once in index.js (v6).

const SUPPORT_EMAIL = 'customerservice@pawtectindia.com';
const SUPPORT_PHONE_1 = '+91-7506562266';
const SUPPORT_PHONE_2 = '+91-20-67445858';

export default function FailedCheckout(props) {

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
    },
  };

  Modal.setAppElement('#root');

  return (
    <Card>
      <div className="page-process-wrapper border-top">
        <div className="container">
          <div className="row no-gutters">
            <div className="col">
              <div>
                <h1>
                  <i className="icon-brochure" style={{ color: '#c0392b', marginRight: '8px' }} aria-hidden="true"></i>
                  Checkout failed
                </h1>
                <p>
                  Thank you for your interest in buying medical cover for your pets. The checkout
                  process could not be completed.
                </p>
                <p>
                  This is usually a temporary issue — for example, the session timed out or your
                  bank declined the request. No order has been placed. If any amount was debited it
                  auto-reverses to your original payment method.
                </p>

                <h2>What you can do</h2>
                <ol>
                  <li>Go back to your cart (the bag icon at the top right) and try again. A new order id will be generated.</li>
                  <li>If you keep seeing this error, contact customer service before retrying.</li>
                </ol>

                <div style={{ margin: '16px 0' }}>
                  <Link to="/" className="btn btn-submit">Go to Cart / Try again</Link>
                </div>

                <div className="payment-support-footer" style={{ marginTop: '24px', paddingTop: '12px', borderTop: '1px solid #e0e0e0' }}>
                  <p>
                    Need help? Call us between 9AM-5PM, Monday to Friday at{' '}
                    <a href={'tel:' + SUPPORT_PHONE_1.replace(/[^+\d]/g, '')}>{SUPPORT_PHONE_1}</a>{' '}or{' '}
                    <a href={'tel:' + SUPPORT_PHONE_2.replace(/[^+\d]/g, '')}>{SUPPORT_PHONE_2}</a>, or email{' '}
                    <a href={'mailto:' + SUPPORT_EMAIL}>{SUPPORT_EMAIL}</a>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clearfix"></div>
      <Modal
        isOpen={false}
        style={customStyles}
        contentLabel="Pawtect Payment"
        ariaHideApp={false}
      >
      </Modal>
    </Card>
  );
}


